import { render, staticRenderFns } from "./vPagamentoSucesso.vue?vue&type=template&id=45f85dd4&scoped=true"
import script from "./vPagamentoSucesso.vue?vue&type=script&lang=js"
export * from "./vPagamentoSucesso.vue?vue&type=script&lang=js"
import style0 from "./vPagamentoSucesso.vue?vue&type=style&index=0&id=45f85dd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f85dd4",
  null
  
)

export default component.exports